import { CommonMessages } from 'appAssets/messages/common.messages';

export const PanelSettingsProductsEditPricesMessages = {
    GetProductFailed: {
        key: 'GetProductFailed',
        message: 'Error while communication with the server. Cannot get available product.'
    },
    ...CommonMessages
};
